import { TUserData } from '../context/Auth';

export const getUserProps = (user?: TUserData) => user?.masquerade ? user?.masquerade.masquerade_user_props : user?.props;

export const getUserRoles = (user?: TUserData) => user?.masquerade ? user?.masquerade.all_roles : user?.all_roles;

